export enum AppRoutesEnum {
    dashboard = 'dashboard',
    calendar = 'calendar',
    profile = 'profile',
    settings = 'settings',
    keyLoans = 'key-loans',
    userAdmin = 'keyorder-user-admin',
    keyAdmin = 'key-admin',
    gatehouseAdmin = 'gatehouseAdmin'
}
